import { createFeatureSelector, createSelector } from '@ngrx/store'
import { FarmState, farmAdapter } from '../reducers/farm.reducer'
import { Features } from '../../../../../state/features.enum'

const { selectIds, selectAll } = farmAdapter.getSelectors()

export const farmsSelector = createFeatureSelector<FarmState>(Features.FARM)

export const selectFarms = createSelector(farmsSelector, selectAll)
export const selectFarmsIds = createSelector(farmsSelector, selectIds)

export const selectFarmById = (farmId: number) =>
  createSelector(selectFarms, (f) => f.filter((farm) => farm?.id === farmId)[0])

export const selectFarmsByIds = (farmIds: number[]) =>
  createSelector(selectFarms, (f) =>
    f.filter((farm) => {
      const id = farm?.id
      return id !== undefined && farmIds.includes(id)
    }),
  )
